import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { JobChangeProcessesResponse, Request } from '../types/JobChangeProcess';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchJobChangeProcesses(searchQuery: Request) {
  const query = qs.stringify(searchQuery, { arrayFormat: 'brackets' });
  return useQuery({
    queryKey: ['jobChangeProcesses', query, 1, ''],
    queryFn: async () => {
      const data = await fetchJson<JobChangeProcessesResponse>(
        `/agent/api/job_change_processes.json?${query}`
      );

      return data;
    },
  });
}
